// src/components/PostDestinationAction.js

import React from 'react';
import { useNavigate } from 'react-router-dom';

import { getPostActionDestination } from '../constants/postActionDestinations';

import './PostDestinationAction.css';

function PostDestinationAction({
  postAction,
  className = '',
  onBeforeNavigate,
}) {
  const navigate = useNavigate();

  const isEnabled = postAction?.enabled === true;
  const destinationKey =
    typeof postAction?.destinationKey === 'string'
      ? postAction.destinationKey.trim()
      : '';

  const label =
    typeof postAction?.label === 'string'
      ? postAction.label.trim()
      : '';

  if (!isEnabled || !destinationKey || !label) {
    return null;
  }

  const destination = getPostActionDestination(destinationKey);

  // Never navigate using a raw route from the database.
  // Unknown or removed destination keys are hidden safely.
  if (!destination?.route) {
    return null;
  }

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (typeof onBeforeNavigate === 'function') {
      onBeforeNavigate({
        destinationKey: destination.key,
        destination,
        postAction,
      });
    }

    navigate(destination.route);
  };

  return (
    <div
      className={`post-destination-action-wrap ${className}`.trim()}
    >
      <button
        type="button"
        className="post-destination-action"
        onClick={handleClick}
        aria-label={`${label}: Open ${destination.title}`}
      >
        <span className="post-destination-action-copy">
          <span className="post-destination-action-label">
            {label}
          </span>

          <span className="post-destination-action-destination">
            {destination.title}
          </span>
        </span>

        <span
          className="post-destination-action-arrow"
          aria-hidden="true"
        >
          ›
        </span>
      </button>
    </div>
  );
}

export default PostDestinationAction;
